import { residentPortalApi } from './residentPortalApi';


residentPortalApi.enhanceEndpoints({
  endpoints: {
    getInviteById: {
      providesTags: (_result, _error, queryArg) => [
        { type: 'InviteController', id: queryArg.id },
      ],
    },
    getInviteByIdVisitLogs: {
      providesTags: (_result, _error, queryArg) => [
        { type: 'InviteController', id: `${queryArg.id}-logs` },
      ],
    },
    patchInviteMarkAsScannedById: {
      
      onQueryStarted: async (queryArg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          if (!data.invite) return;
          dispatch(
            residentPortalApi.util.updateQueryData(
              'getInviteById',
              { id: queryArg.id },
              (draft) => {
                Object.assign(draft, data.invite);
              },
            ),
          );
        } catch {
          // let normal error handling in the caller surface the failure
        }
      },
      invalidatesTags: (_result, _error, queryArg) => [
        { type: 'InviteController', id: 'LIST' },
        { type: 'InviteController', id: `${queryArg.id}-logs` },
      ],
    },
  },
});
